import api from '@pray/shared/utils/api';

import type { EmailHealthReport } from './getEmailHealthReports';

export type GenerateEmailHealthReportParams = {
  orgId: string;
};

export async function generateEmailHealthReport({
  orgId,
}: GenerateEmailHealthReportParams): Promise<EmailHealthReport> {
  const url = `/web/studio/email-health/${orgId}/reports`;
  const response = await api.executePostRequest<{ data: EmailHealthReport }>(url, {});
  return response.data.data;
}
